import React from 'react';
import { Label } from '@pega/cosmos-react-core';
import CustomTooltip from './CustomTooltip';

interface CustomLabelProps {
  label: string;
  showRequired?: boolean;
  tooltipInfo?: string;
}

const CustomLabel: React.FC<CustomLabelProps> = ({ label, showRequired, tooltipInfo }) => {
  return (
    <Label>
      {label} {showRequired && <span style={{ color: '#d91c29' }}>* </span>}
      {tooltipInfo && <CustomTooltip iconName="help" info={tooltipInfo} />}
    </Label>
  );
};

export default CustomLabel;
